var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMenuBack = function SvgMobileMenuBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1000A",
    fillRule: "evenodd",
    d: "M2.283 7 8 12.713 6.63 14 .27 7.644a.904.904 0 0 1 0-1.288L6.63 0 8 1.287z",
    clipRule: "evenodd"
  })));
};
export { SvgMobileMenuBack as ReactComponent };